"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEMA_HASH = void 0;
exports.SCHEMA_HASH = "b2423381608576d4fff3db536d9def9f7d8febc6078e038be8e866de02694a24";
//# sourceMappingURL=schemaHash.js.map